import Alert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Snackbar, { SnackbarCloseReason } from "@mui/material/Snackbar";
import { SyntheticEvent } from "react";
import { useCustomAlertStore } from "@mirage/store/store";

const CustomSnackbar = () => {
    const alertState = useCustomAlertStore((s) => s.customAlert);
    const closeAlert = useCustomAlertStore((s) => s.closeAlert);

    if (!alertState.message) {
        return null;
    }

    return (
        <Snackbar
            className="customSnackbar"
            open={alertState.isOpen}
            autoHideDuration={alertState.duration ? alertState.duration : 3000}
            onClose={(event, reason) => closeSnackbarHandler(event, reason)}
            TransitionComponent={(props) => <Slide {...props} direction="up" />}
        >
            <Alert onClose={closeSnackbarHandler} severity={alertState.severity} className="customSnackbar_alert">
                {alertState.message}
            </Alert>
        </Snackbar>
    );

    function closeSnackbarHandler(event: Event | SyntheticEvent<Element, Event>, reason?: SnackbarCloseReason) {
        if (reason !== "clickaway" && reason !== "escapeKeyDown") {
            closeAlert();
        }
    }
};

export default CustomSnackbar;
